import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addPackaging } from "../../../store/actions"
import { useEffect } from "react"

const AddPackaging = props => {
  const dispatch = useDispatch()
  document.title = "Add packaging"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      packaging: "",
    },
    validationSchema: Yup.object({
      packaging: Yup.string().required("Please Enter Packaging"),
    }),
    onSubmit: values => {
      dispatch(addPackaging(values, props.history))
    },
  })

  const packagings = useSelector(state => state.packaging)
  const { error } = useSelector(state => ({
    error: state.packaging.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Packaging" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formPackaging"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="pck">
                            Packaging
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="packaging"
                            className={
                              validation.touched.packaging &&
                              validation.errors.packaging
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="pck"
                            placeholder="Enter Packaging"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.packaging || ""}
                          />
                          {validation.touched.packaging &&
                          validation.errors.packaging ? (
                            <FormFeedback type="invalid">
                              {validation.errors.packaging}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {packagings && packagings.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddPackaging
